import { Close as CloseIcon } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";

import { QuoteHistoryContainer } from "components/ShipmentQuote/components/QuoteHistory/QuoteHistoryContainer";
import { getQuoteTitle } from "utils";

interface Props {
  open: boolean;
  onClose: () => void;
  quote?: ShipperCondensedQuote;
}

export function QuoteHistoryModal(props: Props) {
  const { open, onClose, quote } = props;

  if (!quote) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Modal Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          flexShrink: 0,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight="bold">
            Quote History for {quote.company?.name ?? "Carrier"}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Shipment #{quote.shipment} · {getQuoteTitle(quote)}
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            "&:hover": { backgroundColor: "action.hover" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Quote History Content */}
      <DialogContent
        sx={{
          flex: 1,
          overflow: "auto",
          p: 3,
        }}
      >
        <QuoteHistoryContainer quoteId={quote.quote} />
      </DialogContent>
    </Dialog>
  );
}
